import { useFormContext } from "react-hook-form"
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form"
import { IMaskInput } from "react-imask"
import { DollarSign } from "lucide-react"
import { cn } from "@/lib/class-control"
import { RequiredMark } from "./required-mark"

interface FormCurrencyFieldProps {
  name: string
  label: string
  placeholder?: string
  required?: boolean
  className?: string
  disabled?: boolean
}

export function FormCurrencyField({
  name,
  label,
  placeholder = "0,00",
  required,
  className,
  disabled
}: FormCurrencyFieldProps) {
  const { control } = useFormContext()

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          <FormLabel className="text-gray-200 text-sm font-semibold">
            {label}
            {required && <RequiredMark />}
          </FormLabel>
          <FormControl>
            <div className="border border-gray-700 rounded-lg h-9 px-4 flex items-center gap-3 hover:border-gray-600 focus-within:border-emerald-500 transition-colors">
              <DollarSign className="w-4 h-4 text-emerald-500" />
              <IMaskInput
                mask={Number}
                thousandsSeparator="."
                radix=","
                scale={2}
                padFractionalZeros
                placeholder={placeholder}
                value={field.value == null ? "" : String(field.value)}
                onAccept={(value) => field.onChange(value)}
                className={cn("bg-transparent border-none outline-none text-emerald-400 text-sm font-semibold w-full",
                  disabled && "cursor-not-allowed opacity-50"
                )}
                disabled={disabled}
              />
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}